import { render, screen } from "@testing-library/react";
import Terria from "../../../lib/Models/Terria";
import ViewState from "../../../lib/ReactViewModels/ViewState";
import { runInAction } from "mobx";
import MapDataCount from "../../../lib/ReactViews/BottomDock/MapDataCount";
import SimpleCatalogItem from "../../Helpers/SimpleCatalogItem";
import { jsx as _jsx } from "react/jsx-runtime";
describe("MapDataCount", function () {
  let terria;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria: terria,
      catalogSearchProvider: undefined
    });
  });
  it("renders noMapDataEnabled when no data on map", function () {
    expect(viewState.useSmallScreenInterface).toEqual(false);
    render(/*#__PURE__*/_jsx(MapDataCount, {
      terria: terria,
      viewState: viewState
    }));
    expect(screen.getByText("countDatasets.noMapDataEnabled")).toBeVisible();
  });
  it("renders count of datasets on map", async function () {
    const simple1 = new SimpleCatalogItem("simple1", terria);
    terria.addModel(simple1);
    await terria.workbench.add(simple1);
    render(/*#__PURE__*/_jsx(MapDataCount, {
      terria: terria,
      viewState: viewState
    }));
    expect(screen.getByText("countDatasets.mapDataState")).toBeVisible();
  });
  it("doesn't render anything when in mobile UI via useSmallScreenInterface", function () {
    runInAction(() => viewState.useSmallScreenInterface = true);
    expect(viewState.useSmallScreenInterface).toEqual(true);
    render(/*#__PURE__*/_jsx(MapDataCount, {
      terria: terria,
      viewState: viewState
    }));
    expect(screen.queryByText("countDatasets.noMapDataEnabled")).not.toBeInTheDocument();
  });
});